export default __webpack_public_path__ + "static/media/siged.c357d519.png";